const models = [
    {
        id: 12,
        name: "plane-engine",
        imgURL: "plane-engine.png",
        modelSRC: ["plane-engine/plane-engine.gltf"],
        iosSRC: [
            "plane-engine/plane-engine.usdz"
        ],
        variants: [],
        hasSpecialCameraOrbit: true,
        cameraOrbit: "180deg 65deg 25m"
    },
  ]

  export default models